module.exports = __webpack_public_path__ + "static/media/rightArrow.2743a2e9.svg";